import React from "react";

// Global safety net: prevents the whole app from turning into a white screen
// when any component throws during render. Shows a friendly, recoverable UI.
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: (error && error.message) || "Erreur inattendue" };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("App error caught by ErrorBoundary:", error, info);
    try {
      const backend = process.env.REACT_APP_BACKEND_URL;
      if (backend) {
        fetch(`${backend}/api/client-error`, {
          method: "POST",
          keepalive: true,
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            message: (error && (error.message || String(error))) || "unknown",
            stack: (error && error.stack) || "",
            componentStack: (info && info.componentStack) || "",
            url: window.location.href,
            ua: navigator.userAgent,
          }),
        }).catch(() => {});
      }
    } catch (e) { /* never throw from the boundary */ }
  }

  handleReload = () => {
    this.setState({ hasError: false, message: "" });
    window.location.reload();
  };

  handleHome = () => {
    this.setState({ hasError: false, message: "" });
    window.location.href = "/studio";
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div
        data-testid="app-error-boundary"
        style={{
          minHeight: "100vh", background: "#0B0D12", color: "#F8FAFC",
          display: "flex", alignItems: "center", justifyContent: "center", padding: 24,
          fontFamily: "system-ui, sans-serif",
        }}
      >
        <div style={{ maxWidth: 440, textAlign: "center" }}>
          <div style={{ fontSize: 40, marginBottom: 8 }}>⚠️</div>
          <h1 style={{ fontSize: 22, fontWeight: 800, margin: "0 0 8px" }}>
            Oups, un souci est survenu
          </h1>
          <p style={{ color: "#94A3B8", fontSize: 14, margin: "0 0 20px" }}>
            L'application a rencontré une erreur, mais rien n'est perdu. Rechargez pour
            reprendre là où vous étiez.
          </p>
          <div style={{ display: "flex", gap: 10, justifyContent: "center" }}>
            <button
              data-testid="error-reload-button"
              onClick={this.handleReload}
              style={{
                background: "#FF5500", color: "#fff", border: "none", borderRadius: 12,
                padding: "12px 20px", fontWeight: 700, cursor: "pointer",
              }}
            >
              Recharger
            </button>
            <button
              data-testid="error-home-button"
              onClick={this.handleHome}
              style={{
                background: "#1A1F2C", color: "#94A3B8", border: "none", borderRadius: 12,
                padding: "12px 20px", fontWeight: 600, cursor: "pointer",
              }}
            >
              Retour au créateur
            </button>
          </div>
        </div>
      </div>
    );
  }
}
